module.exports = __webpack_public_path__ + "static/media/service-main-4.75f499b7.svg";